.sidebar-graphic {
    margin-left: -30px;
}
